<template>
    <div>
        <!-- <button @click="console.log(schema)">输出表单数据</button> -->
        <el-form :model="formModel" label-width="260px" label-position="top" :rules="rules" ref="formRef">
            <template v-for="field in schema" :key="field.key">
                <!-- 依赖判断：不满足条件则不渲染 -->
                <el-form-item v-if="checkDependency(field)" :label="field.title" :prop="field.key"
                    :required="field.is_required">

                    <div style="width: 100%;">
                        <!-- 输入框 -->
                        <el-input size="large" v-if="field.assembly_type === 'input'" v-model="formModel[field.key]"
                            :placeholder="`请输入${field.title}`" clearable />
                        <!-- 数字输入框 -->
                        <el-input-number v-else-if="field.assembly_type === 'number'" v-model="formModel[field.key]"
                            :step="field.step || 1" :min="field.min ?? Number.MIN_SAFE_INTEGER"
                            :max="field.max ?? Number.MAX_SAFE_INTEGER" />

                        <!-- 下拉选择框 -->
                        <el-select v-else-if="field.assembly_type === 'select'" v-model="formModel[field.key]"
                            placeholder="请选择" clearable>
                            <el-option v-for="opt in field.select_data || []" :key="opt.value" :label="opt.label"
                                :value="opt.value" />
                        </el-select>

                        <!-- 开关 -->
                        <el-switch v-else-if="field.assembly_type === 'switch'" v-model="formModel[field.key]" />

                        <!-- 多选框组 -->
                        <el-checkbox-group v-else-if="field.assembly_type === 'checkbox'"
                            v-model="formModel[field.key]">
                            <el-checkbox v-for="opt in field.select_data || []" :key="opt.value" :label="opt.value">
                                {{ opt.label }}
                            </el-checkbox>
                        </el-checkbox-group>

                        <!-- 单选框组 -->
                        <el-radio-group size="large" v-else-if="field.assembly_type === 'radio'"
                            v-model="formModel[field.key]">
                            <el-radio v-for="opt in field.select_data || []" :key="opt.value" :label="opt.value">
                                {{ opt.label }}
                            </el-radio>
                        </el-radio-group>
                        <!-- colorsgrouppicker 颜色组 -->
                        <template v-else-if="field.assembly_type === 'colorsgrouppicker'">
                            <ColorSelect v-model="formModel[field.key]"></ColorSelect>
                        </template>

                    </div>

                    <!-- 提示语 -->
                    <div v-if="field.description" class="form-item-prompt">
                        {{ field.description }}
                    </div>
                </el-form-item>
            </template>
        </el-form>
    </div>
</template>

<script setup>
    import { ref, computed, reactive, watch } from "vue";
    import { useFormStore } from "@/Store/task.js";

    import ColorSelect from "./ColorSelect.vue";

    const formStore = useFormStore();
    const emit = defineEmits(["submit", "reset"]);

    const formModel = reactive({});
    const rules = reactive({});
    const formRef = ref();

    // schema 改为从 store 里取
    // const schema = computed(() => formStore.process_forms || []);

    //固定参数，必须要用
    const taskName_config = {
        key: "task_name",
        assembly_type: "input",
        title: "任务名称",
        default: `task_name_${new Date().getTime()}`,
        is_required: true
    };
    const banned = ["metadata", "filter_data_row", "comparison_group_plan"];
    /*  const schema = computed(() => {
         return (formStore.process_forms || []).filter((field) => !banned.includes(field.category));
     }); */

    const schema = computed(() => {
        const filtered = (formStore.process_forms || []).filter(
            (field) => !banned.includes(field.category)
        );
        return [...filtered, taskName_config]; // taskName_config 放在最后
    });


    // 当 schema 变化时，初始化 formModel & rules
    watch(schema, (newSchema) => {
        Object.keys(formModel).forEach((key) => delete formModel[key]); // 清空旧的
        Object.keys(rules).forEach((key) => delete rules[key]);

        newSchema.forEach((field) => {
            formModel[field.key] = field.default ?? (field.assembly_type === "checkbox" ? [] : "");
            if (field.is_required) {
                rules[field.key] = [{
                    required: true,
                    message: `${field.title}不能为空`,
                    trigger: ["input", "blur", "change"],
                },];
            }
        });
    }, { immediate: true });

    // 检查依赖条件是否满足
    const checkDependency = (field) => {
        if (!field.dependency) return true;
        const dep = field.dependency;
        const depValue = formModel[dep.key];
        switch (dep.operator) {
            case "==": return depValue === dep.value;
            case "!=": return depValue !== dep.value;
            case ">": return depValue > dep.value;
            case "<": return depValue < dep.value;
            default: return true;
        }
    };

    // 暴露方法给父组件
    const submit = async () => {
        return new Promise((resolve, reject) => {
            formRef.value.validate((valid) => {
                if (valid) {
                    /*  emit("submit", { ...formModel }); */
                    resolve({ ...formModel });
                } else {
                    reject("表单校验未通过");
                }
            });
        });
    };

    const reset = () => {
        formRef.value.resetFields();
        emit("reset");
    };

    defineExpose({
        submit,
        reset,
        formModel,
    });
</script>
<style scoped>
    .form-item-prompt {
        display: block;
        width: 100%;
        font-size: 14px;
        color: #757D8A;
        margin-top: 4px;
        line-height: normal;
    }
</style>